module.exports = __webpack_public_path__ + "static/media/BNB12.18236469.png";